export enum TaskState {
  Done = 'done',
  Inprogress = 'in progress',
  Blocked = 'blocked',
}
